import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VOverlay,{attrs:{"absolute":"","value":_vm.loading}},[_c(VProgressCircular,{attrs:{"indeterminate":"","size":"160"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }